import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { NotificationManager } from "react-notifications";

import productsService from "@services/products";
import historyService from "@services/history";
import taxService from "@services/tax";
import ispService from "@services/isp";
import providersService from "@services/providers";
import categoriesService from "@services/categories";
import postosService from "@services/postos";
import aiService from "@services/ai";
import ImageUploading from "react-images-uploading";

// Components
import Menu from "@components/Menu";
import Checkbox from "@components/CheckBox";
import Switch from "@components/Switch";

/* Import Components */
import EmpresaSelect from "@components/EmpresaSelect";
import Input from "@components/Input";
import AutoComplete from "@components/AutoComplete";
import ReactTable from "@components/ReactTable";
import Button from "@components/Button";
import HorizontalTabs from "@components/HorizontalTabs/.";
import VerticalTabs from "@components/VerticalTabs/.";
import { MDBDataTable } from "mdbreact";
import { MdAddCircleOutline, MdEmail, MdPhone, MdHome, MdDelete } from "react-icons/md";
import Barcode from "react-barcode";
import Modal from '@components/Modal';
import { EventBus as eventBus } from "@components/EventBus";

import "react-tabs/style/react-tabs.css";

import { threeDecimal, valueWithIva, valueWithoutIva } from "@utils/format.js";
import { TimestampToDate } from "@utils/date";
import { getTaxSelectLabel } from "@utils/taxLabel";
import { TranslateTable, TranslateAction, TranslateLocation } from "@utils/history";

import "./form.css";

import UserContext from "@components/context/userContext";

const dataURLtoFile = (dataurl, fileName) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
};

class Form extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const {
      match: { params },
      type,
    } = this.props;

    this.state = {
      taxes: [],
      isps: [],
      isp: {},
      tabIndex: params.tabIndex,
      redirect: params.redirect,
      loaded: false,
      newbarcode: '',
      ativo: true,
      mov_stock: true,
      limite_semanal_switch: false,
      limite_semanal: 0,
      composed: false,
      fuel: false,
      gas: false,
      price: "",
      price_iva: "",
      costprice: "",
      costprice_iva: "",
      iva: {},
      idproduct: { value: params.idproduct },
      idcategory: { value: "" },
      idproduto: "",
      edit: type === "edit",
      categories: [],
      selectedCategory: null,
      warehouses: [],
      barcodes: [],
      nome: "",
      obs_guias: "",
      image: null,
      avatar: null,
      pendingImage: null,
      showFetchImagesModal: false,
      externalImages: [],
      fetchingImages: false,
      imageSearchQuery: '',
      selectedExternalImage: null,
      samePrices: true,
      samePVPValue: '',
      samePCValue: '',
      sameIVAValue: '',
      sameSYNCValue: true,
      prices: {
        columns: [
          {
            label: "Posto",
            field: "nome",
          },
          {
            label: "PVP c/IVA",
            field: "price",
          },
          {
            label: "P. Custo s/IVA",
            field: "costprice",
          },
          {
            label: "Margem s/IVA",
            field: "profit",
          },
          {
            label: "Margem (%)",
            field: "profitper",
          },
          {
            label: "IVA",
            field: "iva",
          },
          {
            label: "Sincronizar",
            field: "sync",
          },
        ],
        rows: [],
      },
      stockConfigs: {
        columns: [
          {
            label: "Posto",
            field: "nome",
          },
          {
            label: "Stock Min.",
            field: "stock_min",
          },
          {
            label: "DCE",
            field: "stock_dce",
          },
          {
            label: "Qtd. Embalagem",
            field: "stock_box",
          },
          {
            label: "Margem de erro (%)",
            field: "stock_threshold",
          },
        ],
        rows: [],
      },
      stockTableStructure: {
        columns: [
          {
            label: "Posto",
            field: "nome",
          },
          {
            label: "Estado",
            field: "status",
          },
          {
            label: "Quantidade",
            field: "quantity",
          },
          {
            label: "P.C.M.",
            field: "average",
          },
          {
            label: "P. Custo",
            field: "last_order",
          },
        ],
        rows: [],
      },
      movEntradas: {
        data: [],
        pages: null,
        loading: true,
        columns: [
          {
            Header: "Data",
            id: "date_time",
            accessor: (d) => TimestampToDate(d.date_time),
          },
          {
            Header: "Posto",
            id: "posto",
            accessor: (d) => d.postoname || d.posto,
          },
          {
            Header: "Doc",
            accessor: "doc",
          },
          {
            Header: "Tipo Doc",
            id: "type",
            accessor: (d) => this.translateType(d.type),
          },
          {
            Header: "Qty",
            id: "quantity",
            accessor: (d) => d.type === 'inventory' ? d.stock : d.quantity,
          },
          {
            Header: "Stock",
            accessor: "stock",
          },
          {
            Header: "P.U.",
            accessor: "total",
          },
        ],
      },
      movEntradasSaidas: {
        data: [],
        pages: null,
        loading: true,
        columns: [
          {
            Header: "Data",
            id: "date_time",
            accessor: (d) => TimestampToDate(d.date_time),
          },
          {
            Header: "Posto",
            id: "posto",
            accessor: (d) => d.postoname || d.posto,
          },
          {
            Header: "Doc",
            accessor: "doc",
          },
          {
            Header: "Operador",
            id: "operador",
            accessor: (d) => d['nome_operador'] || d['vd_utilizador'] || d['f_utilizador'],
          },
          {
            Header: "Tipo Doc",
            id: "type",
            accessor: (d) => this.translateType(d.type),
          },
          {
            Header: "Qty",
            id: "quantity",
            accessor: (d) => d.type === 'inventory' ? d.stock : d.quantity,
          },
          {
            Header: "Stock",
            accessor: "stock",
          },
          {
            Header: "P.U.",
            accessor: "total",
          },
        ],
      },
      movSaidas: {
        data: [],
        pages: null,
        loading: true,
        columns: [
          {
            Header: "Data",
            id: "date_time",
            accessor: (d) => TimestampToDate(d.date_time),
          },
          {
            Header: "Posto",
            id: "posto",
            accessor: (d) => d.postoname || d.posto,
          },
          {
            Header: "Doc",
            accessor: "doc",
          },
          {
            Header: "Operador",
            id: "operador",
            accessor: (d) => d['nome_operador'] || d['vd_utilizador'] || d['f_utilizador'],
          },
          {
            Header: "Tipo Doc",
            id: "type",
            accessor: (d) => this.translateType(d.type),
          },
          {
            Header: "Qty",
            id: "quantity",
            accessor: (d) => d.type === 'inventory' ? d.stock : d.quantity,
          },
          {
            Header: "Stock",
            accessor: "stock",
          },
          {
            Header: "P.U.",
            accessor: "total",
          },
        ],
      },
      historyData: {
        data: [],
        pages: null,
        loading: true,
        search: '',
        columns: [
          {
            Header: "Data",
            id: "date_time",
            accessor: (d) => TimestampToDate(d.date_time),
          },
          {
            Header: "Tabela",
            id: "table",
            accessor: (d) => TranslateTable(d.table),
          },
          {
            Header: "Ação",
            id: "action",
            accessor: (d) => TranslateAction(d.action),
          },
          {
            Header: "Ferramenta",
            id: "location",
            accessor: (d) => TranslateLocation(d.location),
          },
          {
            Header: "Alterações",
            id: "changes",
            accessor: (d) => d, // Passamos o objeto completo
            Cell: ({ value: rowData }) => {
              try {
                const oldData = typeof rowData.old === 'string' ? JSON.parse(rowData.old) : (rowData.old || {});
                const newData = typeof rowData.new === 'string' ? JSON.parse(rowData.new) : (rowData.new || {});
                
                const oldObj = typeof oldData === 'object' && oldData !== null ? oldData : {};
                const newObj = typeof newData === 'object' && newData !== null ? newData : {};
                
                // Obter todas as chaves únicas
                const allKeys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);
                
                const changes = [];
                
                allKeys.forEach(key => {
                  const oldValue = oldObj[key];
                  const newValue = newObj[key];
                  
                  if (oldValue === undefined && newValue !== undefined) {
                    // Novo campo adicionado
                    changes.push(
                      <div 
                        key={key} 
                        style={{ 
                          marginBottom: '8px',
                          padding: '8px 12px',
                          backgroundColor: '#d4edda',
                          borderLeft: '3px solid #28a745',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        <i className="fas fa-plus-circle" style={{ color: '#28a745', fontSize: '14px' }}></i>
                        <div style={{ flex: 1 }}>
                          <span style={{ fontWeight: '600', color: '#155724', fontSize: '13px' }}>{key}</span>
                          <span style={{ color: '#155724', marginLeft: '8px', fontSize: '13px' }}>{String(newValue)}</span>
                        </div>
                      </div>
                    );
                  } else if (oldValue !== undefined && newValue === undefined) {
                    // Campo removido
                    changes.push(
                      <div 
                        key={key} 
                        style={{ 
                          marginBottom: '8px',
                          padding: '8px 12px',
                          backgroundColor: '#f8d7da',
                          borderLeft: '3px solid #dc3545',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        <i className="fas fa-minus-circle" style={{ color: '#dc3545', fontSize: '14px' }}></i>
                        <div style={{ flex: 1 }}>
                          <span style={{ fontWeight: '600', color: '#721c24', fontSize: '13px' }}>{key}</span>
                          <span style={{ color: '#721c24', textDecoration: 'line-through', marginLeft: '8px', fontSize: '13px', opacity: 0.7 }}>{String(oldValue)}</span>
                        </div>
                      </div>
                    );
                  } else if (oldValue !== newValue) {
                    // Campo modificado
                    changes.push(
                      <div 
                        key={key} 
                        style={{ 
                          marginBottom: '8px',
                          padding: '8px 12px',
                          backgroundColor: '#fff3cd',
                          borderLeft: '3px solid #ffc107',
                          borderRadius: '4px'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                          <i className="fas fa-edit" style={{ color: '#856404', fontSize: '14px' }}></i>
                          <span style={{ fontWeight: '600', color: '#856404', fontSize: '13px' }}>{key}</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginLeft: '22px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ 
                              fontSize: '12px', 
                              color: '#721c24', 
                              backgroundColor: '#f8d7da',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              textDecoration: 'line-through'
                            }}>
                              {String(oldValue)}
                            </span>
                            <i className="fas fa-arrow-right" style={{ color: '#856404', fontSize: '10px' }}></i>
                            <span style={{ 
                              fontSize: '12px', 
                              color: '#155724', 
                              backgroundColor: '#d4edda',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              fontWeight: '500'
                            }}>
                              {String(newValue)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  }
                });
                
                if (changes.length === 0) {
                  return (
                    <div style={{ 
                      maxWidth: '450px', 
                      padding: '12px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '4px',
                      border: '1px solid #dee2e6',
                      textAlign: 'center',
                      color: '#6c757d',
                      fontSize: '13px'
                    }}>
                      <i className="fas fa-info-circle" style={{ marginRight: '6px' }}></i>
                      Sem alterações
                    </div>
                  );
                }
                
                return (
                  <div style={{ maxWidth: '450px', wordBreak: 'break-word' }}>
                    {changes}
                  </div>
                );
              } catch (error) {
                return (
                  <div style={{ 
                    maxWidth: '450px', 
                    padding: '12px',
                    backgroundColor: '#f8d7da',
                    borderRadius: '4px',
                    border: '1px solid #dc3545',
                    color: '#721c24',
                    fontSize: '13px'
                  }}>
                    <i className="fas fa-exclamation-triangle" style={{ marginRight: '6px' }}></i>
                    Erro ao processar alterações
                  </div>
                );
              }
            },
          },
          {
            Header: "Posto",
            id: "idposto",
            accessor: (d) => d.idposto !== -1 ? d.idposto : '' ,
          },
          {
            Header: "Utilizador",
            id: "employee",
            accessor: (d) => d.employee ? d.employee : '' ,
          },
        ],
      },
      products: [],
      composition: [],
      suppliers: [],
      selectedSuppliers: [],
      idprovider: '',
      selectedProduct: '',
      selectedquantity: 1,
      newProductCode: '',
      changeCodeConfirmText: '',
      showChangeCodeConfirmModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handlePriceSubmit = this.handlePriceSubmit.bind(this);
    this.handleSamePriceSubmit = this.handleSamePriceSubmit.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
    this.handleTableSubmit = this.handleTableSubmit.bind(this);
    this.fetchMovEntradasData = this.fetchMovEntradasData.bind(this);
    this.fetchMovEntradasSaidasData = this.fetchMovEntradasSaidasData.bind(this);
    this.fetchMovSaidasData = this.fetchMovSaidasData.bind(this);
    this.fetchHistoryData = this.fetchHistoryData.bind(this);
    this.translateType = this.translateType.bind(this);
    this.getRealIdOrder = this.getRealIdOrder.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleBarcodeSubmitSuccess = this.handleBarcodeSubmitSuccess.bind(this);
    this.handleBarcodeDeleteSuccess = this.handleBarcodeDeleteSuccess.bind(this);
    this.handleCompositionSubmitSuccess = this.handleCompositionSubmitSuccess.bind(this);
    this.handleCompositionDeleteSuccess = this.handleCompositionDeleteSuccess.bind(this);
    this.handleSuppliersSubmit = this.handleSuppliersSubmit.bind(this);
    this.handleCompositionSubmit = this.handleCompositionSubmit.bind(this);
    this.addSupplier = this.addSupplier.bind(this);
    this.doSave = this.doSave.bind(this);
    this.handleFetchImagesClick = this.handleFetchImagesClick.bind(this);
    this.fetchExternalImages = this.fetchExternalImages.bind(this);
    this.handleImageSelect = this.handleImageSelect.bind(this);
    this.handleFetchImagesClose = this.handleFetchImagesClose.bind(this);
    this.handleFetchImageWithAI = this.handleFetchImageWithAI.bind(this);
    this.handleChangeCodeClick = this.handleChangeCodeClick.bind(this);
    this.handleChangeCodeClose = this.handleChangeCodeClose.bind(this);
    this.handleChangeCodeSubmit = this.handleChangeCodeSubmit.bind(this);
    this.handleChangeCodeConfirm = this.handleChangeCodeConfirm.bind(this);
  }

  onImageChange = async (imageList, addUpdateIndex) => {
    console.log('onImageChange called with:', imageList);
    const profile = this.context;
    
    // Se não há imagens, limpar o estado
    if (!imageList || imageList.length === 0) {
      this.setState({ image: null });
      return;
    }

    // Preparar FormData para upload
    const formData = new FormData();
    formData.append(
      "photo",
      dataURLtoFile(imageList[0]["data_url"], imageList[0].file.name)
    );
    formData.append("idempresa", profile.idEmpresaSec);
    formData.append("idproduct", this.state.idproduto || this.state.idproduct.value);

    // Verificar se estamos em modo de edição
    if (this.props.type === "edit") {
      // Em edição, fazer upload imediatamente
      console.log('Uploading image for product:', this.state.idproduto || this.state.idproduct.value);

      try {
        const result = await productsService.setPhoto(formData);
        console.log('Upload result:', result);
        this.setState({ image: imageList[0] });
        this.setState({ loaded: false });
        this.loadFunction();
        NotificationManager.success('Imagem atualizada com sucesso', 'Sucesso', 3000);
      } catch (error) {
        console.error('Erro ao fazer upload da imagem:', error);
        NotificationManager.error('Erro ao fazer upload da imagem', 'Erro', 5000);
      }
    } else {
      // Em criação, apenas guardar para upload posterior no doSave
      this.setState({ pendingImage: imageList[0] });
    }
  }

  uploadPendingImage = async (idProduct) => {
    const profile = this.context;
    
    if (!this.state.pendingImage) {
      return Promise.resolve();
    }

    // Preparar FormData para upload
    const formData = new FormData();
    formData.append(
      "photo",
      dataURLtoFile(this.state.pendingImage["data_url"], this.state.pendingImage.file.name)
    );
    formData.append("idempresa", profile.idEmpresaSec);
    formData.append("idproduct", idProduct);

    try {
      const result = await productsService.setPhoto(formData);
      this.setState({ pendingImage: null });
      NotificationManager.success('Imagem enviada com sucesso', 'Sucesso', 3000);
      return Promise.resolve(result);
    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
      NotificationManager.error('Erro ao fazer upload da imagem', 'Erro', 5000);
      return Promise.reject(error);
    }
  }

  handleRemoveImage = async () => {
    const profile = this.context;
    const idproduct = this.state.idproduto || this.state.idproduct.value;

    if (!idproduct) {
      NotificationManager.error('Produto não encontrado', 'Erro', 5000);
      return;
    }

    try {
      await productsService.unsetPhoto(profile.idEmpresaSec, idproduct);
      this.setState({ image: null, avatar: null });
      
      // Recarregar dados do produto
      if (this.props.type === "edit") {
        this.setState({ loaded: false });
        this.loadFunction();
      }
      
      NotificationManager.success('Imagem removida com sucesso', 'Sucesso', 3000);
    } catch (error) {
      console.error('Erro ao remover imagem:', error);
      NotificationManager.error('Erro ao remover imagem', 'Erro', 5000);
    }
  }

  handleFileChange = async (event) => {
    console.log('handleFileChange called');
    const file = event.target.files[0];
    if (!file) {
      console.log('No file selected');
      return;
    }

    console.log('File selected:', file.name, file.type);

    const reader = new FileReader();
    reader.onloadend = () => {
      console.log('FileReader onloadend');
      const imageData = {
        data_url: reader.result,
        file: file
      };
      console.log('Calling onImageChange with:', imageData);
      this.onImageChange([imageData], 0);
    };
    reader.readAsDataURL(file);
    
    // Reset the input
    event.target.value = '';
  }

  handleFetchImagesClick() {
    // Usar nome/designação do produto por defeito
    const searchQuery = this.state.nome || '';
    
    this.setState({
      showFetchImagesModal: true,
      imageSearchQuery: searchQuery,
      externalImages: [],
      fetchingImages: false,
      selectedExternalImage: null
    });
    
    // Se temos uma query, buscar automaticamente
    if (searchQuery) {
      this.fetchExternalImages();
    }
  }

  async fetchExternalImages() {
    const { imageSearchQuery } = this.state;
    const profile = this.context;
    
    if (!imageSearchQuery) {
      NotificationManager.warning('Por favor, introduza um código de barras ou nome do produto', 'Aviso', 3000);
      return;
    }
    
    this.setState({ fetchingImages: true });
    
    try {
      // Tentar usar modo idempresa + idproduct se estivermos em edição
      let result;
      const idprodutoToUse = this.state.idproduto || (this.state.idproduct && this.state.idproduct.value);
      
      if (this.props.type === "edit" && idprodutoToUse) {
        result = await productsService.fetchImagesByProduct(profile.idEmpresaSec, idprodutoToUse);
      } else {
        // Usar modo query para nome ou código de barras
        result = await productsService.fetchImages(imageSearchQuery);
      }
      
      if (result.success && result.images && result.images.length > 0) {
        this.setState({ 
          externalImages: result.images,
          fetchingImages: false 
        });
      } else {
        this.setState({ 
          externalImages: [],
          fetchingImages: false 
        });
        NotificationManager.info('Nenhuma imagem encontrada', 'Informação', 3000);
      }
    } catch (error) {
      console.error('Erro ao buscar imagens:', error);
      this.setState({ fetchingImages: false });
      NotificationManager.error('Erro ao buscar imagens', 'Erro', 5000);
    }
  }

  async handleImageSelect(imageUrl) {
    this.setState({ selectedExternalImage: imageUrl });
  }

  async handleUseSelectedImage() {
    const { selectedExternalImage } = this.state;
    
    if (!selectedExternalImage) {
      NotificationManager.warning('Por favor, selecione uma imagem', 'Aviso', 3000);
      return;
    }
    
    try {
      // Carregar a imagem de URL externa e converter para formato usável
      const response = await fetch(selectedExternalImage);
      const blob = await response.blob();
      const reader = new FileReader();
      
      reader.onloadend = async () => {
        const imageData = {
          data_url: reader.result,
          file: new File([blob], 'product_image.jpg', { type: blob.type })
        };
        
        // Fechar modal
        this.setState({ 
          showFetchImagesModal: false,
          selectedExternalImage: null,
          externalImages: [],
          imageSearchQuery: ''
        });
        
        // Processar a imagem como se fosse um upload normal
        await this.onImageChange([imageData], 0);
        
        NotificationManager.success('Imagem carregada com sucesso', 'Sucesso', 3000);
      };
      
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Erro ao carregar imagem:', error);
      NotificationManager.error('Erro ao carregar imagem', 'Erro', 5000);
    }
  }

  handleFetchImagesClose() {
    this.setState({ 
      showFetchImagesModal: false,
      externalImages: [],
      imageSearchQuery: '',
      selectedExternalImage: null,
      fetchingImages: false
    });
  }

  async handleFetchImageWithAI() {
    const profile = this.context;
    const idprodutoToUse = this.state.idproduto || (this.state.idproduct && this.state.idproduct.value);
    
    if (!idprodutoToUse) {
      NotificationManager.warning('Apenas disponível para produtos existentes', 'Aviso', 3000);
      return;
    }
    
    try {
      NotificationManager.info('A procurar melhor imagem com IA...', 'A processar', 3000);
      const result = await aiService.fetchBestImageWithAI(profile.idEmpresaSec, idprodutoToUse);
      
      if (result.success && result.best_image_url) {
        // Tentar buscar a imagem via proxy do servidor
        try {
          const blob = await productsService.fetchImageProxy(result.best_image_url);
          const reader = new FileReader();
          
          reader.onloadend = async () => {
            const imageData = {
              data_url: reader.result,
              file: new File([blob], 'product_image.jpg', { type: blob.type })
            };
            
            await this.onImageChange([imageData], 0);
            
            NotificationManager.success('Imagem selecionada por IA carregada com sucesso', 'Sucesso', 3000);
          };
          
          reader.readAsDataURL(blob);
        } catch (proxyError) {
          console.error('Erro ao buscar imagem via proxy:', proxyError);
          NotificationManager.error('Erro ao carregar imagem via servidor', 'Erro', 5000);
        }
      } else {
        NotificationManager.warning('Nenhuma imagem encontrada pela IA', 'Aviso', 3000);
      }
    } catch (error) {
      console.error('Erro ao buscar imagem com IA:', error);
      NotificationManager.error('Erro ao buscar imagem com IA', 'Erro', 5000);
    }
  }

  handleChangeCodeClick() {
    this.setState({
      newProductCode: '',
      changeCodeConfirmText: ''
    });
  }

  handleChangeCodeClose() {
    this.setState({
      newProductCode: '',
      changeCodeConfirmText: ''
    });
  }

  async handleChangeCodeSubmit() {
    const { newProductCode, changeCodeConfirmText } = this.state;
    const oldIdproduct = this.state.idproduto || this.state.idproduct.value;

    // Validações
    if (!newProductCode || newProductCode.trim() === '') {
      NotificationManager.error('Por favor, introduza o novo código do produto', 'Erro', 5000);
      return;
    }

    if (newProductCode === oldIdproduct) {
      NotificationManager.error('O novo código deve ser diferente do código atual', 'Erro', 5000);
      return;
    }

    if (changeCodeConfirmText !== 'CONFIRMAR') {
      NotificationManager.error('Por favor, escreva "CONFIRMAR" para confirmar a alteração', 'Erro', 5000);
      return;
    }

    // Abrir modal de confirmação
    this.setState({ showChangeCodeConfirmModal: true });
  }

  async handleChangeCodeConfirm() {
    const profile = this.context;
    const { newProductCode } = this.state;
    const oldIdproduct = this.state.idproduto || this.state.idproduct.value;

    try {
      // Fechar modal
      this.setState({ showChangeCodeConfirmModal: false });
      
      NotificationManager.info('A alterar código do produto...', 'A processar', 3000);
      
      const result = await productsService.changeProductCode(
        profile.idEmpresaSec,
        oldIdproduct,
        newProductCode.trim()
      );

      if (result.success) {
        NotificationManager.success('Código do produto alterado com sucesso', 'Sucesso', 3000);
        
        // Limpar campos
        this.handleChangeCodeClose();
        
        // Redirecionar para a ficha do produto novo
        setTimeout(() => {
          window.location.href = `/products/${newProductCode.trim()}`;
        }, 1000);
      } else {
        NotificationManager.error(result.error || 'Erro ao alterar código do produto', 'Erro', 5000);
      }
    } catch (error) {
      console.error('Erro ao alterar código do produto:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Erro ao alterar código do produto';
      NotificationManager.error(errorMessage, 'Erro', 5000);
    }
  }

  translateType(type) {
    switch (type) {
      case "linhas":
        return "Talão";
      case "facturaslinhas":
        return "Fatura";
      case "vendasdinheirolinhas":
        return "Fatura Recibo";
      case "notascreditolinhas":
        return "Nota de Crédito";
      case "orders":
        return "Compra";
      case "transfer":
        return "Transferência";
      case "returns":
        return "Devolução";
      case "earnings":
      case "losses":
      case "inventory":
        return "Inventário";
      default:
        return "";
    }
  }

  getRealIdOrder(entry) {
    const mapping = {
      linhas: 'taloes',
      facturaslinhas: 'facturas',
      vendasdinheirolinhas: 'vendas_dinheiro',
    };
    switch (entry.type) {
      case "linhas":
      case "facturaslinhas":
      case "vendasdinheirolinhas":
        return `/sales/${(mapping[entry.type])}${["linhas"].includes(entry.type) ? `/${entry.posto}/${entry.tpv}` : ""}/${entry.serie}/${entry.numero}`;
      case "earnings":
      case "losses":
      case "inventory":
      default:
        return `/orders/${entry.doc}/products/${this.state.idproduct.value}`;
    }
  }

  handleCheckboxChange(e) {
    let value = e.target.checked;
    let name = e.target.name;

    let newState = this.state;

    if (name.includes("|")) {
      const properties = name.split("|");

      newState[properties[0]][properties[1]][properties[2]] = value;
      newState[properties[0]][properties[1]]["changed"] = true;

      this.setState({
        ...newState,
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  }

  fetchMovEntradasData(state, instance) {
    const profile = this.context;

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({
      movEntradas: { ...this.state.movEntradas, loading: true },
    });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    const idposto = instance.props.warehouse;
    const doctypes = ['orders', 'transfer', 'earnings'];
    
    const getTransactions = idposto === "all" 
      ? productsService.getTransactionsById(profile.idEmpresaSec, this.state.idproduct.value, doctypes, state.page, state.pageSize)
      : productsService.getTransactionsByWarehouse(profile.idEmpresaSec, idposto, this.state.idproduct.value, doctypes, state.page, state.pageSize);
    
    getTransactions
      .then((productTransactions) => {

        this.setState({
          movEntradas: {
            ...this.state.movEntradas,
            data: productTransactions.entries.map((entry) => ({
              ...entry,
              doc: ["orders", "transfer", "earnings"].includes(
                entry.type
              ) ? (
                <a href={this.getRealIdOrder(entry)} target="popup">
                  {entry.doc}
                </a>
              ) : (
                entry.doc
              ),
            })),
            pages: productTransactions.totalPages,
            loading: false,
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchMovEntradasSaidasData(state, instance) {
    const profile = this.context;

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({
      movEntradasSaidas: { ...this.state.movEntradasSaidas, loading: true },
    });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    const idposto = instance.props.warehouse;
    const doctypes = ['orders', 'transfer', 'earnings', 'sales', 'transfer', 'returns', 'losses'];
    
    const getTransactions = idposto === "all" 
      ? productsService.getTransactionsById(profile.idEmpresaSec, this.state.idproduct.value, doctypes, state.page, state.pageSize)
      : productsService.getTransactionsByWarehouse(profile.idEmpresaSec, idposto, this.state.idproduct.value, doctypes, state.page, state.pageSize);
    
    getTransactions
      .then((productTransactions) => {

        this.setState({
          movEntradasSaidas: {
            ...this.state.movEntradasSaidas,
            data: productTransactions.entries.map((entry) => ({
              ...entry,
              doc: ["orders", "transfer", "earnings", "returns", "transfer", "losses", "linhas", "facturaslinhas", "vendasdinheirolinhas", "inventory"].includes(
                entry.type
              ) ? (
                <a href={this.getRealIdOrder(entry)} target="popup">
                  {entry.doc}
                </a>
              ) : (
                entry.doc
              ),
            })),
            pages: productTransactions.totalPages,
            loading: false,
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchMovSaidasData(state, instance) {
    const profile = this.context;
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ movSaidas: { ...this.state.movSaidas, loading: true } });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    const idposto = instance.props.warehouse;
    const doctypes = ['sales', 'transfer', 'returns', 'losses'];
    
    const getTransactions = idposto === "all" 
      ? productsService.getTransactionsById(profile.idEmpresaSec, this.state.idproduct.value, doctypes, state.page, state.pageSize)
      : productsService.getTransactionsByWarehouse(profile.idEmpresaSec, idposto, this.state.idproduct.value, doctypes, state.page, state.pageSize);
    
    getTransactions
      .then((productTransactions) => {

        this.setState({
          movSaidas: {
            ...this.state.movSaidas,
            data: productTransactions.entries.map((entry) => ({
              ...entry,
              doc: ["returns", "transfer", "losses", "linhas", "facturaslinhas", "vendasdinheirolinhas"].includes(
                entry.type
              ) ? (
                <a href={this.getRealIdOrder(entry)} target="popup">
                  {entry.doc}
                </a>
              ) : (
                entry.doc
              ),
            })),
            pages: productTransactions.totalPages,
            loading: false,
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchHistoryData(state, instance) {
    const profile = this.context;
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    this.setState({ historyData: { ...this.state.historyData, loading: true } });
    
    const search = this.state.historyData.search || '';
    const page = state.page || 1;
    const pageSize = state.pageSize || 10;
    
    historyService.getHistory(profile.idEmpresaSec, this.state.idproduct.value, search, page, pageSize, ['products', 'products_values'])
      .then((data) => {
        // Calcular total de páginas baseado no número de resultados
        // Se retornar menos que pageSize, é a última página
        // Caso contrário, assumimos que há mais páginas (usamos page + 1 como estimativa)
        const totalPages = data.length < pageSize ? page : (data.length === pageSize ? page + 1 : page);
        
        this.setState({
          historyData: {
            ...this.state.historyData,
            data: data,
            pages: totalPages,
            loading: false,
          },
        });
      })
      .catch((error) => {
        console.error('Erro ao buscar histórico:', error);
        this.setState({
          historyData: {
            ...this.state.historyData,
            data: [],
            pages: 0,
            loading: false,
          },
        });
      });
  }

  loadFunction() {
    const profile = this.context;
    if (!this.state.loaded) {
      taxService.get()
      .then(taxes => {
          this.setState({ taxes: taxes.map((tax) => ({ ...tax, value: tax.code, label: getTaxSelectLabel(tax) })), loaded: true });
      })
      .catch(error => {
          console.error(error);
      });

      ispService.get(profile.idEmpresaSec)
      .then(isps => {
          this.setState({ isps: [
            {
              value: '',
              codigo: '',
              label: 'NENHUM',
            },
            ...isps.map((eachIsp) => ({ ...eachIsp, value: eachIsp.codigo, label: eachIsp.descricao_isp }))
          ], loaded: true });
      })
      .catch(error => {
          console.error(error);
      });

      if (this.props.type === "edit") {
        productsService
        .get(profile.idEmpresaSec)
        .then((products) => {
          this.setState({ products: products.map((product) => ({
            label: `[${product.idproduct}] ${product.nome}`,
            value: product.idproduct
          })) });
        })
        .catch((error) => {
          console.error(error);
        });
        Promise.all([
          providersService.get(profile.idEmpresaSec)
            .then(suppliers => {
                this.setState({ suppliers: suppliers.map((provider) => ({ ...provider, value: provider.idprovider, label: provider.name })), loaded: true });
            })
            .catch(error => {
                console.error(error);
            }),
          categoriesService
            .get(profile.idEmpresaSec)
            .then(async (categories) => {
              await this.setState({
                categories: categories.map((category) => ({
                  value: category.idcategoria,
                  label: `[${category.idcategoria}] ${category.descricaocategoria}`,
                  ...category, // Include all category properties
                })),
                loaded: true,
              });

              productsService
                .getById(profile.idEmpresaSec, this.state.idproduct.value)
                .then(async (response) => {
                  const product = response && response.length > 0 ? response[0] : [];
                  product.name = product.nome;
                  product.price = threeDecimal(product.price);
                  product.price_iva = threeDecimal(
                    valueWithIva(product.price, product.iva)
                  );
                  product.costprice = threeDecimal(product.costprice);
                  product.costprice_iva = threeDecimal(
                    valueWithIva(product.costprice, product.iva)
                  );

                  const foundCategory = this.state.categories.find(({ value }) => value === product.idcategoria);
                  
                  await this.setState({
                    ...product,
                    ativo: !(product.inativo === 't'),
                    mov_stock: !(product.nao_mov_stock === 't'),
                    limite_semanal_switch: product.limite_semanal > 0,
                    limite_semanal: product.limite_semanal || 0,
                    composed: product.composed === 't',
                    fuel: product.fuel === 't',
                    gas: product.gas === 't',
                    idcategory: foundCategory,
                    selectedCategory: foundCategory,
                    avatar: product.image,
                    isp: this.state.isps.find(({ codigo }) => codigo === product.isp) || {
                      value: '',
                      codigo: '',
                      label: 'NENHUM',
                    },
                    idproduct: { value: product.idproduct },
                    selectedSuppliers: product.providers ? product.providers.map((provider) => provider.idprovider) : [],
                  });
                  productsService
                    .getCompositionById(profile.idEmpresaSec, this.state.idproduct.value)
                    .then(async (composition) => {
                      await this.setState({
                        composition
                      });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                })
                .catch((error) => {
                  console.error(error);
                });
            })
            .catch((error) => {
              console.error(error);
            }),
          postosService
            .get(profile.idEmpresaSec)
            .then(async (warehouses) => {
              await this.setState({ warehouses });
              
              // Atualizar colunas do histórico para incluir os warehouses carregados
              if (this.state.historyData && this.state.historyData.columns) {
                const updatedColumns = this.state.historyData.columns.map(col => {
                  if (col.id === 'idposto') {
                    return {
                      ...col,
                      accessor: (d) => {
                        if (parseInt(d.idposto?.trim(), 10) === -1 || !d.idposto) return '';
                        if (!warehouses || !Array.isArray(warehouses) || warehouses.length === 0) {
                          return d.idposto;
                        }
                        const warehouse = warehouses.find((w) => w.idposto === d.idposto || w.posto === d.idposto);
                        return warehouse?.nome || d.idposto;
                      },
                    };
                  }
                  return col;
                });
                this.setState({
                  historyData: {
                    ...this.state.historyData,
                    columns: updatedColumns,
                  },
                });
              }

              
              await Promise.all([
                ...warehouses.map((warehouse) =>
                  postosService.getStockById(profile.idEmpresaSec, this.state.idproduct.value, warehouse.posto)
                ),
              ]).then(async (responses) => {
                let stocksByPosto = {};
                const allStocks = responses
                  .map((response) => response && response.length > 0 ? response[0] : 0)
                  .filter((response) => response !== 0)

                if (allStocks.length > 0) {
                  stocksByPosto = allStocks.reduce((acc, stock) => ({
                    ...acc,
                    [stock.idposto]: stock,
                  }), {});
                }
                await productsService
                    .getPriceById(profile.idEmpresaSec, this.state.idproduct.value)
                    .then(async (prices) => {
                      const pricesByPosto = prices.reduce(
                        (acc, price) => ({
                          ...acc,
                          [price.idposto]: {
                            ...price,
                          },
                        }),
                        {}
                      );
                      const newWarehousesState = this.state.warehouses.map((warehouse) => {
                        const values =
                          (
                            pricesByPosto[warehouse.posto] || { values: [] }
                          ).values.find(
                            (value) => parseInt(value.tpv, 10) === 0
                          ) || {};
                        return {
                          ...warehouse,
                          quantity: stocksByPosto[warehouse.posto] ? stocksByPosto[warehouse.posto].stock : 0,
                          flags: stocksByPosto[warehouse.posto] ? stocksByPosto[warehouse.posto].flags : [],
                          prices: pricesByPosto[warehouse.posto] || {},
                          price: values.price,
                          costprice: values.costprice,
                          iva: this.state.taxes.find((tax) => tax.code === values.iva),
                          stock_min: values.stock_min,
                          stock_dce: values.stock_dce,
                          stock_box: values.stock_box,
                          stock_threshold: values.stock_threshold,
                          sync: values.sync === "t",
                        };
                      });
                      const samePrices = newWarehousesState.length <= 0 ||
                      newWarehousesState.every((item) =>
                        item.price === newWarehousesState[0].price &&
                        item.costprice === newWarehousesState[0].costprice &&
                        item.iva === newWarehousesState[0].iva &&
                        item.sync === newWarehousesState[0].sync
                      );
                      if (samePrices && newWarehousesState.length > 0) {
                        await this.setState({
                          samePVPValue: newWarehousesState[0].price,
                          samePCValue: newWarehousesState[0].costprice,
                          sameIVAValue: newWarehousesState[0].iva,
                          sameSYNCValue: newWarehousesState[0].sync,
                        });
                      }

                      const sameStocks = newWarehousesState.length <= 0 ||
                      newWarehousesState.every((item) =>
                        item.stock_min === newWarehousesState[0].stock_min &&
                        item.stock_dce === newWarehousesState[0].stock_dce &&
                        item.stock_box === newWarehousesState[0].stock_box &&
                        item.stock_threshold === newWarehousesState[0].stock_threshold
                      );
                      if (sameStocks && newWarehousesState.length > 0) {
                        await this.setState({
                          sameStockMinValue: newWarehousesState[0].stock_min,
                          sameStockDceValue: newWarehousesState[0].stock_dce,
                          sameStockBoxValue: newWarehousesState[0].stock_box,
                          sameStockThresholdValue: newWarehousesState[0].stock_threshold,
                        });
                      }
                      await this.setState({
                        samePrices,
                        sameStocks,
                        warehouses: newWarehousesState,
                      });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
              })
            })
            .catch((error) => {
              console.error(error);
            }),
        ]).then(() => {
          this.setState({ loaded: true });
        });
      } else {
        postosService
          .get(profile.idEmpresaSec)
          .then(async (warehouses) => {
            await this.setState({ warehouses });
          });
        categoriesService
          .get(profile.idEmpresaSec)
          .then(async (categories) => {

            const formattedCategories = categories.map((category) => ({
              value: category.idcategoria,
              label: `[${category.idcategoria}] ${category.descricaocategoria}`,
              ...category, // Include all category properties
            }));

                 // Always try to find and set selectedCategory if we have idcategory
                 let selectedCategory = null;
                 if (this.state.idcategory && this.state.idcategory.value) {
                   selectedCategory = formattedCategories.find(cat => cat.value === this.state.idcategory.value);
                 }

                 await this.setState({
                   categories: formattedCategories,
                   selectedCategory: selectedCategory,
                   loaded: true,
                 });
          });
      }
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    let newState = this.state;

    if (name.includes("|")) {
      const properties = name.split("|");

      if (properties.length === 4) {
        newState[properties[0]][properties[1]][properties[2]][properties[3]] = value;
      } else {
        newState[properties[0]][properties[1]][properties[2]] = value;
        newState[properties[0]][properties[1]]["changed"] = true;
      }


      this.setState({
        ...newState,
      });
    } else {
      if (name === "samePrices") {
        this.setState({
          [name]: !newState[name],
        });
      } else if (name === "sameStocks") {
        this.setState({
          [name]: !newState[name],
        });
      } else {
        this.setState({
          [name]: value,
        });
        
        // Update selectedCategory when idcategory changes
        if (name === "idcategory" && value && value.value) {
          const selectedCategory = this.state.categories.find(cat => cat.value === value.value);
          this.setState({
            selectedCategory: selectedCategory,
            // Set fuel and gas based on category properties
            fuel: selectedCategory && selectedCategory.combustivel === 't' ? true : false,
            gas: selectedCategory && selectedCategory.gas === 't' ? true : false
          });
        }
      }
    }

    if (typeof callback === 'function') {
      callback();
    }
  }

  doSave(profile, idProduct, redirect) {
    if (this.state.edit) {
      if (this.state.samePrices && this.state.sameSYNCValue) {
        if (!this.state.sameIVAValue || !this.state.sameIVAValue.code) {
          return NotificationManager.error("Por favor, selecione um IVA válido.", "Erro", 5000);
        }
        if (!this.state.samePVPValue || !this.state.samePVPValue < 0) {
          return NotificationManager.error("Por favor, selecione um PVP válido.", "Erro", 5000);
        }
      } else if (!this.state.samePrices) {
        const considerWarehouse = this.state.warehouses.filter((warehouse) => warehouse.sync);
        if (considerWarehouse.some((warehouse) => !warehouse.iva || !warehouse.iva.code)) {
          return NotificationManager.error("Por favor, selecione um IVA válido para todos os postos.", "Erro", 5000);
        }
        if (considerWarehouse.some((warehouse) => !warehouse.price || !warehouse.price < 0)) {
          return NotificationManager.error("Por favor, selecione um PVP válido.", "Erro", 5000);
        }
      }
    }

    const payload = {
      price: this.state.price,
      costprice: this.state.costprice,
      iva: (this.state.iva && this.state.iva.value),
      idempresa: profile.idEmpresaSec,
      idproduct: idProduct,
      name: this.state.name,
      idcategory: this.state.idcategory.value,
      isp: this.state.isp.value,
      ativo: this.state.ativo ? 't' : 'f',
      mov_stock: this.state.mov_stock ? 't' : 'f',
      limite_semanal: this.state.limite_semanal_switch ? this.state.limite_semanal : 'NULL',
      composed: this.state.composed ? 't' : 'f',
      fuel: this.state.fuel ? 't' : 'f',
      gas: this.state.gas ? 't' : 'f',
      providers: this.state.selectedSuppliers,
      obs_guias: this.state.obs_guias || '',
    };

    if(this.state.sameStocks) {
      const { sameStockMinValue, sameStockDceValue, sameStockBoxValue, sameStockThresholdValue } = this.state;
      payload.same_stock = true;
      payload.stock_value = {
        idposto: -1,
        stock_min: sameStockMinValue,
        stock_dce: sameStockDceValue,
        stock_box: sameStockBoxValue,
        stock_threshold: sameStockThresholdValue,
      };
    } else {
      payload.stock_values = this.state.warehouses
          .filter((warehouse) => warehouse.changed)
          .map((warehouse) => ({
            ...warehouse,
            idposto: warehouse.posto
          }));
    }

    productsService
        .set(payload)
        .then((response) => {
          Promise.all([
            this.handleTableSubmit(idProduct),
            this.handleCompositionSubmit(idProduct),
            this.handleSuppliersSubmit(idProduct),
            this.state.samePrices ? this.handleSamePriceSubmit(idProduct) : this.handlePriceSubmit(idProduct),
            this.uploadPendingImage(idProduct),
          ])
          .then(() => {
            if (redirect) {
              switch (redirect) {
                case "sync":
                  window.location.href = "/products/sync";
                  break;
                default:
                  if (this.state.edit) {
                    window.location.href = "/products";
                  } else {
                    window.location.href = `/products/${idProduct}`;
                  }
                  break;
              }
            } else {
              if (this.state.edit) {
                window.location.href = "/products";
              } else {
                window.location.href = `/products/${idProduct}`;
              }
            }
          })
        })
        .catch((error) => {
          console.error(error);
        });
  }

  handleFormSubmit(e) {
    const profile = this.context;
    const { redirect } = this.state;
    e.preventDefault();
    if (this.state.idproduto || this.state.idproduct.value) {
      const idProduct = this.state.idproduto || this.state.idproduct.value;
      if (this.props.type !== "edit") {
        productsService
          .getById(profile.idEmpresaSec, idProduct)
          .then(async (response) => {
            if (response && response[0]) {
              alert("Já existe um produto com o mesmo código!")
              return;
            } else {
              this.doSave(profile, idProduct, redirect)
            }
          })
      } else {
        this.doSave(profile, idProduct, redirect)
      }
    }
  }

  handleTableSubmit(idproduct) {
    const profile = this.context;
    return productsService
      .setStocks({
        idempresa: profile.idEmpresaSec,
        idproduct: idproduct,
        stocks: this.state.warehouses
          .filter((warehouse) => warehouse.changed)
          .map((warehouse) => ({
            ...warehouse,
            idposto: warehouse.posto,
          })),
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handlePriceSubmit(idproduct) {
    const profile = this.context;
    return productsService
      .setPrices({
        idempresa: profile.idEmpresaSec,
        idproduct: idproduct,
        values: this.state.warehouses
          .filter((warehouse) => warehouse.changed)
          .map((warehouse) => ({
            ...warehouse,
            idposto: warehouse.posto,
            iva: warehouse.iva?.code
          })),
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleCompositionSubmit(idproduct) {
    const profile = this.context;
    return productsService
      .setComposition({
        idempresa: profile.idEmpresaSec,
        idproduct: idproduct,
        composition: this.state.composition,
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSuppliersSubmit(idproduct) {
    const profile = this.context;
    return productsService
      .setProviders({
        idempresa: profile.idEmpresaSec,
        idproduct: idproduct,
        providers: this.state.selectedSuppliers,
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSamePriceSubmit(idproduct) {
    const profile = this.context;
    const { samePVPValue, samePCValue, sameIVAValue, sameSYNCValue } = this.state;
    return productsService
      .setPrices({
        idempresa: profile.idEmpresaSec,
        idproduct: idproduct,
        same: true,
        value: {
          idposto: -1,
          price: samePVPValue,
          costprice: samePCValue,
          iva: sameIVAValue.value,
          sync: sameSYNCValue,
        },
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleFormCancel() {
    const { history } = this.props;
    const { redirect } = this.state;

    if (redirect) {
      switch (redirect) {
        case "sync":
          window.location.href = "/products/sync";
          break;
        default:
          history.push("/products");
          break;
      }
    } else {
      history.push("/products");
    }
  }

  handleBarcodeSubmitSuccess() {
    const profile = this.context;
    if (this.state.idproduto || this.state.idproduct.value) {
      this.setState({ idproduct: { value: this.state.idproduto || this.state.idproduct.value } });
      productsService
        .setBarcode({
          idempresa: profile.idEmpresaSec,
          idproduct: this.state.idproduto || this.state.idproduct.value,
          barcode: this.state.newbarcode,
        })
        .then((response) => {
          eventBus.$emit("Modal-barcodes", { isOpen: false });
          this.setState({
            newbarcode: '',
            barcodes:
              this.state.barcodes.find((barcode) => barcode === this.state.newbarcode)
              ? this.state.barcodes
              : [...this.state.barcodes, {
                idempresa: profile.idEmpresaSec,
                idproduct: this.state.idproduto || this.state.idproduct.value,
                barcode: this.state.newbarcode
              }],
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  handleBarcodeDeleteSuccess(currentBarcode) {
    const profile = this.context;
    if (this.state.idproduto || this.state.idproduct.value) {
      this.setState({ idproduct: { value: this.state.idproduto || this.state.idproduct.value } });
      productsService
        .unsetBarcode({
          idempresa: profile.idEmpresaSec,
          idproduct: this.state.idproduto || this.state.idproduct.value,
          barcode: currentBarcode,
        })
        .then((response) => {
          this.setState({
            barcodes: this.state.barcodes.filter((barcode) => barcode !== currentBarcode),
          });
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  handleCompositionSubmitSuccess() {
    const profile = this.context;
    if (this.state.idproduto || this.state.idproduct.value) {
      this.setState({ idproduct: { value: this.state.idproduto || this.state.idproduct.value } });
      productsService
        .setComposition({
          idempresa: profile.idEmpresaSec,
          idproduct: this.state.idproduto || this.state.idproduct.value,
          idproduct2: this.state.selectedProduct.value,
          quantity: this.state.selectedquantity,
        })
        .then((response) => {
          eventBus.$emit("Modal-composition", { isOpen: false });
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  handleCompositionDeleteSuccess(item) {
    const profile = this.context;

    productsService
        .unsetComposition(profile.idEmpresaSec, this.state.idproduto || this.state.idproduct.value, item.idproduct2)
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
  }

  addSupplier(e, callback) {
    let value = e.target.value;

    this.setState({ idprovider: '', selectedSuppliers: [...this.state.selectedSuppliers, value.value] });
  }


  render() {
    const { location, history } = this.props;
    const { selectedCategory } = this.state;
    
    const {
      edit,
      loaded,
      idproduto,
      idproduct,
      newbarcode,
      name,
      ativo,
      mov_stock,
      limite_semanal,
      limite_semanal_switch,
      composed,
      fuel,
      gas,
      idcategory,
      warehouses,
      categories,
      stockTableStructure,
      prices,
      movEntradas,
      movEntradasSaidas,
      movSaidas,
      historyData,
      barcodes,
      tabIndex,
      samePrices,
      samePVPValue,
      samePCValue,
      sameIVAValue,
      sameSYNCValue,
      stockConfigs,
      sameStocks,
      sameStockMinValue,
      sameStockDceValue,
      sameStockBoxValue,
      sameStockThresholdValue,
      taxes,
      selectedProduct,
      selectedquantity,
      products,
      composition,
      isps,
      isp,
      suppliers,
      selectedSuppliers,
      idprovider,
      obs_guias,
      image,
      avatar,
      pendingImage,
      showFetchImagesModal,
      externalImages,
      fetchingImages,
      imageSearchQuery,
      selectedExternalImage,
      newProductCode,
      changeCodeConfirmText,
      showChangeCodeConfirmModal,
    } = this.state;
    const cookies = new URLSearchParams(location.search);
    const profile = this.context;
    const isAdmin = profile && profile.memberType === 10;

    // Check if ISP column should show (when at least one of fuel or gas is active in the product)
    const showISPColumn = fuel || gas;

    // Show fuel config section only when category has Combustível or Gás flag
    const showFuelConfig = selectedCategory && (selectedCategory.combustivel === 't' || selectedCategory.gas === 't');

    const sameIVA = sameIVAValue;

    const priceTable = {
      ...prices,
      autoWidth: true,
      rows: samePrices
        ? [{
          nome: 'TODOS POSTOS',
          price: (
            <input
              type="number"
              key={'samePVPValue'}
              name={'samePVPValue'}
              value={ samePVPValue }
              onChange={this.handleChange}
              style={{
                border: (!samePVPValue || samePVPValue === '' || samePVPValue === null || samePVPValue === undefined) && sameSYNCValue
                  ? '2px solid #dc3545'
                  : '1px solid #ced4da'
              }}
            />
          ),
          costprice: (
            <input
              type="number"
              key={'samePCValue'}
              name={'samePCValue'}
              value={ samePCValue }
              onChange={this.handleChange}
            />
          ),
          profit: (valueWithoutIva(samePVPValue, sameIVA ? sameIVA.tax : 0) - samePCValue).toFixed(3),
          profitper: samePCValue > 0 ? (100 - (samePCValue * 100 / valueWithoutIva(samePVPValue, sameIVA ? sameIVA.tax : 0))).toFixed(2) : 100,
          iva: (
            <AutoComplete
              name={"sameIVAValue"}
              value={sameIVA}
              handleChange={this.handleChange}
              options={taxes}
              customStyles={{
                control: (base, state) => ({
                  ...base,
                  border: (!sameIVA || !sameIVA.value || sameIVA.value === '' || sameIVA.value === null || sameIVA.value === undefined) && sameSYNCValue
                    ? '2px solid #dc3545'
                    : base.border,
                  boxShadow: state.isFocused && (!sameIVA || !sameIVA.value || sameIVA.value === '' || sameIVA.value === null || sameIVA.value === undefined) && sameSYNCValue
                    ? '0 0 0 1px #dc3545'
                    : state.isFocused
                    ? '0 0 0 1px #2684ff'
                    : 'none'
                })
              }}
            />
          ),
          sync: (
            <Checkbox
              key={'sameSYNCValue'}
              name={'sameSYNCValue'}
              checked={sameSYNCValue}
              handleChange={this.handleCheckboxChange}
            />
          ),
        }]
        : warehouses
        .map((warehouse, index) => {
          const iva = warehouse.iva
          const isEmptyPrice = !warehouse.price || warehouse.price === '' || warehouse.price === null || warehouse.price === undefined;
          const isEmptyIva = !iva || !iva.value || iva.value === '' || iva.value === null || iva.value === undefined;
          const shouldHighlightPrice = isEmptyPrice && warehouse.sync;
          const shouldHighlightIva = isEmptyIva && warehouse.sync;
          
          return {
            nome: warehouse.nome,
            price: (
              <input
                type="number"
                key={`warehouses|${index}|price`}
                name={`warehouses|${index}|price`}
                value={warehouse.price}
                onChange={this.handleChange}
                style={{
                  border: shouldHighlightPrice
                    ? '2px solid #dc3545'
                    : '1px solid #ced4da'
                }}
              />
            ),
            costprice: (
              <input
                type="number"
                key={`warehouses|${index}|costprice`}
                name={`warehouses|${index}|costprice`}
                value={warehouse.costprice}
                onChange={this.handleChange}
              />
            ),
            profit: (valueWithoutIva(warehouse.price, iva ? iva.tax : 0) - warehouse.costprice).toFixed(3),
            profitper: warehouse.costprice > 0 ? (100 - (warehouse.costprice * 100 / valueWithoutIva(warehouse.price, iva ? iva.tax : 0))).toFixed(2) : 100,
            iva: (
              <AutoComplete
                name={`warehouses|${index}|iva`}
                value={iva}
                handleChange={this.handleChange}
                options={taxes}
                customStyles={{
                  control: (base, state) => ({
                    ...base,
                    border: shouldHighlightIva
                      ? '2px solid #dc3545'
                      : base.border,
                    boxShadow: state.isFocused && shouldHighlightIva
                      ? '0 0 0 1px #dc3545'
                      : state.isFocused
                      ? '0 0 0 1px #2684ff'
                      : 'none'
                  })
                }}
              />
            ),
            sync: (
              <Checkbox
                key={`warehouses|${index}|sync`}
                name={`warehouses|${index}|sync`}
                checked={warehouse.sync}
                handleChange={this.handleCheckboxChange}
              />
            ),
          }
        })
        .filter(({ posto }) => parseInt(posto, 10) !== 0),
    };

    const stockConfigTable = {
      ...stockConfigs,
      autoWidth: true,
      rows: sameStocks
        ? [{
          nome: 'TODOS POSTOS',
          stock_min: (
            <input
              type="number"
              key={'sameStockMinValue'}
              name={'sameStockMinValue'}
              value={ sameStockMinValue }
              onChange={this.handleChange}
            />
          ),
          stock_dce: (
            <input
              type="number"
              key={'sameStockDceValue'}
              name={'sameStockDceValue'}
              value={ sameStockDceValue }
              onChange={this.handleChange}
            />
          ),
          stock_box: (
            <input
              type="number"
              key={'sameStockBoxValue'}
              name={'sameStockBoxValue'}
              value={ sameStockBoxValue }
              onChange={this.handleChange}
            />
          ),
          stock_threshold: (
            <input
              type="number"
              key={'sameStockThresholdValue'}
              name={'sameStockThresholdValue'}
              value={ sameStockThresholdValue }
              onChange={this.handleChange}
            />
          ),
        }]
        : warehouses
        .map((warehouse, index) => {
          return {
            nome: warehouse.nome,
            stock_min: (
              <input
                type="number"
                key={`warehouses|${index}|stock_min`}
                name={`warehouses|${index}|stock_min`}
                value={warehouse.stock_min}
                onChange={this.handleChange}
              />
            ),
            stock_dce: (
              <input
                type="number"
                key={`warehouses|${index}|stock_dce`}
                name={`warehouses|${index}|stock_dce`}
                value={warehouse.stock_dce}
                onChange={this.handleChange}
              />
            ),
            stock_box: (
              <input
                type="number"
                key={`warehouses|${index}|stock_box`}
                name={`warehouses|${index}|stock_box`}
                value={warehouse.stock_box}
                onChange={this.handleChange}
              />
            ),
            stock_threshold: (
              <input
                type="number"
                key={`warehouses|${index}|stock_threshold`}
                name={`warehouses|${index}|stock_threshold`}
                value={warehouse.stock_threshold}
                onChange={this.handleChange}
              />
            ),
          }
        })
        .filter(({ posto }) => parseInt(posto, 10) !== 0),
    };    

    const compositionTable = {
      columns: [
        {
          label: "Produto",
          field: "product2",
        },
        {
          label: "Quantidade",
          field: "quantityinput",
        },
        {
          label: "",
          field: "edit",
        },
      ],
      rows: composition.map((item, index) => {
        const product = (products.find(({value}) => value === item.idproduct2) || {});
        return {
          ...item,
          product2: product.label,
          quantityinput: (
            <input
              type="number"
              key={`composition|${index}|quantity`}
              name={`composition|${index}|quantity`}
              value={ item.quantity }
              onChange={this.handleChange}
            />
          ),
          edit: (
            <i style={{ fontSize: '15px', cursor: 'pointer' }} onClick={ () => this.handleCompositionDeleteSuccess(item) } className="fas fa-trash"></i>
          ),
        }
      }),
    };

    const stockTable = {
      ...stockTableStructure,
      rows: warehouses.map((warehouse, index) => ({
        nome: warehouse.nome,
        quantity: warehouse.quantity,
        status: (warehouse.flags || []).map(({key, value}) => {
          if (key === 'LOW_STOCK') {
            // return value === 'WARN' ? (
            //   <span className="badge badge-warning">Stock baixo</span>
            // ) : (
            //   <span className="badge badge-danger">Stock muito baixo</span>
            // )
            return null;
          } else {
            return null;
          }
        }),
        average: warehouse.prices && threeDecimal(warehouse.prices.average),
        last_order:
          warehouse.prices && threeDecimal(warehouse.prices.last_order),
      })),
    };

    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li>
                <a href="/products">Produtos</a>
              </li>
              <li className="active">
                {edit ? <span>{name}</span> : <span>Novo Produto</span>}
              </li>
            </ol>
          </div>
        </div>
        <EmpresaSelect />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          {loaded && (
            <HorizontalTabs
              tabIndex={tabIndex}
              tabs={{
                details: {
                  label: "Detalhes",
                  page: (
                    <div>
                      <div
                        className="fullContainer"
                        style={{ maxWidth: "100%" }}
                      >
                        <div
                          className="col-sm-12"
                          style={{ textAlign: "left" }}
                        >
                          <div className="panel panel-default">
                            <div
                              className="panel-heading"
                              style={{
                                fontWeight: "bold",
                                fontSize: "15pt",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "15px 20px",
                                backgroundColor: ativo ? "#f5f5f5" : "#fee2e2",
                              }}
                            >
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", gap: "8px" }}>
                                Detalhes
                                <h6 style={{ margin: 0, fontSize: "14px", fontWeight: "normal" }}>
                                  {edit ? (
                                    <span>{name}</span>
                                  ) : (
                                    <span>Novo Produto</span>
                                  )}
                                </h6>
                              </div>
                              {edit && (
                                <div style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "8px 12px",
                                  backgroundColor: ativo ? "#ffffff" : "#fef2f2",
                                  borderRadius: "8px",
                                  border: ativo ? "1px solid #dee2e6" : "1px solid #dc3545",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                  color: ativo ? "#495057" : "#dc3545"
                                }}>
                                  <span style={{
                                    fontSize: "0.75rem",
                                    fontWeight: "600",
                                    color: ativo ? "#495057" : "#dc3545",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px"
                                  }}>
                                    Ativo
                                  </span>
                                  <div>
                                    <Switch
                                      name={"ativo"}
                                      checked={ativo}
                                      handleChange={this.handleChange}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                            <form
                              style={{
                                textAlign: "left",
                                width: "100%",
                                padding: "20px",
                                backgroundColor: ativo ? "#ffffff" : "rgb(254 242 242 / 87%)",
                              }}
                              className="container-fluid"
                              onSubmit={this.handleFormSubmit}
                            >
                              {/* Informações Básicas */}
                              <div className="product-basic-info-section" style={{ marginBottom: "30px" }}>
                                <h4 style={{ marginBottom: "20px", color: "#2b4c7e", fontWeight: "600" }}>Informações Básicas</h4>
                                
                                <div className="product-basic-info-grid" style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "30px" }}>
                                  {/* Coluna 1: Campos do Produto */}
                                  <div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                      <div className="product-basic-fields-row" style={{ display: "flex", flexDirection: "row", gap: "20px" }}>

                                        <div>
                                          <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                            Código do Produto
                                          </label>
                                          {idproduct.value ? (
                                            <div style={{ padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef" }}>
                                              {idproduct.value}
                                            </div>
                                          ) : (
                                            <Input
                                              inputType={"text"}
                                              name={"idproduto"}
                                              value={idproduto}
                                              handleChange={this.handleChange}
                                            />
                                          )}
                                        </div>
                                        
                                        <div>
                                          <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                            Designação
                                          </label>
                                          <Input
                                            inputType={"text"}
                                            name={"name"}
                                            value={name}
                                            handleChange={this.handleChange}
                                          />
                                        </div>
                                      </div>
                                      
                                      <div>
                                        <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                          Família/Categoria
                                        </label>
                                        <AutoComplete
                                          name={"idcategory"}
                                          value={idcategory}
                                          handleChange={this.handleChange}
                                          options={categories}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Coluna 2: Imagem do Produto */}
                                  <div>
                                    <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                      Imagem do Produto
                                    </label>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={this.handleFileChange}
                                      style={{ display: 'none' }}
                                      id="product-image-input"
                                    />
                                    <ImageUploading
                                      multiple={false}
                                      value={image ? [image] : []}
                                      onChange={this.onImageChange}
                                      maxNumber={1}
                                      dataURLKey="data_url"
                                    >
                                    {({
                                      onImageUpload,
                                      onImageRemove,
                                      isDragging,
                                      dragProps,
                                    }) => (
                                      <div className="upload__image-wrapper">
                                        <div style={{ marginTop: "15px" }}>
                                          <div style={{ position: "relative", display: "inline-block" }}>
                                            <img
                                              src={avatar ? `https://eposgestofinal.com/${avatar}` : (image ? image.data_url : (pendingImage ? pendingImage.data_url : 'https://eposgestofinal.com/site/images/product.png'))}
                                              alt="Produto"
                                              style={{
                                                maxWidth: "200px",
                                                maxHeight: "200px",
                                                borderRadius: "8px",
                                                border: "1px solid #dee2e6",
                                                padding: "5px",
                                                backgroundColor: "#f8f9fa"
                                              }}
                                            />
                                            <div style={{ position: "absolute", top: "5px", right: "5px", display: "flex", gap: "5px" }}>
                                              {edit && (
                                                <button
                                                  type="button"
                                                  onClick={this.handleFetchImageWithAI}
                                                  style={{
                                                    backgroundColor: "#9c27b0",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "20%",
                                                    width: "50px",
                                                    height: "28px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                                  }}
                                                  title="Encontrar melhor imagem com IA"
                                                >
                                                  <i className="fas fa-robot"></i> <span style={{ fontSize: "12px" }}>AI</span>
                                                </button>
                                              )}
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  console.log('Edit button clicked, avatar:', avatar, 'image:', image);
                                                  
                                                  // Always use the file input for changing images
                                                  console.log('Triggering file input');
                                                  const fileInput = document.getElementById('product-image-input');
                                                  if (fileInput) {
                                                    console.log('File input found, clicking');
                                                    fileInput.click();
                                                  } else {
                                                    console.log('File input NOT found');
                                                  }
                                                }}
                                                style={{
                                                  backgroundColor: "#007bff",
                                                  color: "white",
                                                  border: "none",
                                                  borderRadius: "50%",
                                                  width: "28px",
                                                  height: "28px",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontSize: "14px",
                                                  fontWeight: "bold",
                                                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                                }}
                                                title="Alterar imagem"
                                              >
                                                <span role="img" aria-label="Alterar imagem">✏️</span>
                                              </button>
                                              <button
                                                type="button"
                                                onClick={this.handleRemoveImage}
                                                style={{
                                                  backgroundColor: "#dc3545",
                                                  color: "white",
                                                  border: "none",
                                                  borderRadius: "50%",
                                                  width: "28px",
                                                  height: "28px",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontSize: "14px",
                                                  fontWeight: "bold",
                                                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                                }}
                                                title="Remover imagem"
                                              >
                                                ×
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </ImageUploading>
                                  </div>
                                </div>
                              </div>

                              {/* Configurações de Combustível - apenas se a categoria tiver flag Combustível ou Gás */}
                              {showFuelConfig && (
                              <div style={{ marginBottom: "30px" }}>
                                <h4 style={{ marginBottom: "20px", color: "#2b4c7e", fontWeight: "600" }}>Configurações de Combustível</h4>
                                <div className="fuel-config-grid" style={{ display: "grid", gap: "20px" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <Switch
                                      name={"fuel"}
                                      checked={fuel}
                                      handleChange={this.handleChange}
                                    />
                                    <span style={{ fontWeight: "500", color: "#555" }}>Combustível</span>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <Switch
                                      name={"gas"}
                                      checked={gas}
                                      handleChange={this.handleChange}
                                    />
                                    <span style={{ fontWeight: "500", color: "#555" }}>Gás</span>
                                  </div>
                                  <div style={{ gridColumn: "span 2" }}>
                                    {showISPColumn && (
                                      <div>
                                        <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                          ISP (Imposto Especial de Consumo)
                                        </label>
                                        <AutoComplete
                                          name={"isp"}
                                          value={isp}
                                          handleChange={this.handleChange}
                                          options={isps}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              )}

                              {/* Configurações de Stock */}
                              <div style={{ marginBottom: "30px" }}>
                                <h4 style={{ marginBottom: "20px", color: "#2b4c7e", fontWeight: "600" }}>Gestão de Stock</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <Switch
                                      name={"mov_stock"}
                                      checked={mov_stock}
                                      handleChange={this.handleChange}
                                    />
                                    <div>
                                      <div style={{ fontWeight: "600", color: "#2b4c7e" }}>Movimentar Stock</div>
                                      <div style={{ fontSize: "0.875rem", color: "#666" }}>Ativar controlo de stock</div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", flexDirection: "column", gap: "8px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
                                      <Switch
                                        name={"limite_semanal_switch"}
                                        checked={limite_semanal_switch}
                                        handleChange={this.handleChange}
                                      />
                                      <div style={{ fontWeight: "600", color: "#2b4c7e" }}>Limite Semanal</div>
                                    </div>
                                    {limite_semanal_switch && (
                                      <Input
                                        inputType={"number"}
                                        name={"limite_semanal"}
                                        value={limite_semanal}
                                        handleChange={this.handleChange}
                                        placeholder="Quantidade"
                                      />
                                    )}
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                                    <Switch
                                      name={"composed"}
                                      checked={composed}
                                      handleChange={this.handleChange}
                                    />
                                    <div>
                                      <div style={{ fontWeight: "600", color: "#2b4c7e" }}>Produto Composto</div>
                                      <div style={{ fontSize: "0.875rem", color: "#666" }}>Definir receita/produção</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Observações para Guias de Transporte */}
                              <div style={{ marginBottom: "30px" }}>
                                <h4 style={{ marginBottom: "20px", color: "#2b4c7e", fontWeight: "600" }}>Observações</h4>
                                <div>
                                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                    Observações (Guias de Transporte)
                                  </label>
                                  <Input
                                    inputType={"text"}
                                    name={"obs_guias"}
                                    value={obs_guias || ""}
                                    handleChange={this.handleChange}
                                  />
                                  <div style={{ fontSize: "0.875rem", color: "#666", marginTop: "5px" }}>
                                    Estas observações aparecerão nas Guias de Transporte quando este produto for utilizado
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                },
                prices: edit ? {
                  label: "Preços",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Preços{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div class="prices-page">
                              <Checkbox
                                key={"samePrices"}
                                name={"samePrices"}
                                title={"Aplicar preços iguais em todos os postos"}
                                checked={samePrices}
                                handleChange={this.handleCheckboxChange}
                              />
                              <MDBDataTable
                                data={priceTable}
                                striped
                                bordered
                                searching={false}
                                paging={false}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Preços",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                },
                stocks: mov_stock ? (edit ? {
                  label: "Stocks",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Stocks{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div>
                              <MDBDataTable
                                data={stockTable}
                                striped
                                bordered
                                searching={false}
                                paging={false}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Configuração de encomenda{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div class="prices-page">
                              <Checkbox
                                key={"sameStocks"}
                                name={"sameStocks"}
                                title={"Aplicar configuração igual em todos os postos"}
                                checked={sameStocks}
                                handleChange={this.handleCheckboxChange}
                              />
                              <MDBDataTable
                                data={stockConfigTable}
                                striped
                                bordered
                                searching={false}
                                paging={false}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Fornecedores{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <>
                              <div style={{ margin: "15px", border: "1px solid rgb(229, 231, 235)", borderRadius: "10px", padding: "15px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ width: "500px" }}>
                                  <AutoComplete
                                    title={"Adicionar Fornecedor"}
                                    handleChange={this.addSupplier}
                                    value={idprovider}
                                    options={suppliers.filter((supplier) => !selectedSuppliers.includes(supplier.idprovider))}
                                  />
                                </div>
                              </div>
                              {selectedSuppliers.length > 0 ? (
                                <div style={{ margin: "15px", border: "1px solid rgb(229, 231, 235)", borderRadius: "10px", padding: "15px" }}>
                                  <label>Fornecedores Selecionados</label>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", margin: "15px" }}>
                                    {suppliers.filter((supplier) => selectedSuppliers.includes(supplier.idprovider)).map((supplier, index) => (
                                        <div style={{ textAlign: "left", padding: "15px", border: "2px solid rgb(229, 231, 235)", borderRadius: "10px", width: "400px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                          <div>
                                            <div style={{ fontWeight: "bolder", fontSize: '14pt', wordBreak: "break-word", whiteSpace: "normal" }}>
                                              {supplier.name}
                                            </div>
                                            {supplier.address ? (
                                              <div className="detail-item" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                                {String(supplier.address || '').split('\n').map((line, idx) => (
                                                  <React.Fragment key={idx}>
                                                    {line}
                                                    {idx < String(supplier.address || '').split('\n').length - 1 && <br />}
                                                  </React.Fragment>
                                                ))}
                                              </div>
                                            ) : null}
                                            {supplier.email ? (
                                              <div className="detail-item">
                                                <MdEmail size={16} />
                                                <span>{supplier.email}</span>
                                              </div>
                                            ) : null}
                                            {supplier.phone ? (
                                              <div className="detail-item">
                                                <MdPhone size={16} />
                                                <span>{supplier.phone}</span>
                                              </div>
                                            ) : null}
                                          </div>
                                          <div style={{ width: "30px" }}>
                                            <MdDelete size={16} color="rgb(239, 68, 68)" style={{ cursor: "pointer" }} onClick={() => this.setState({ selectedSuppliers: selectedSuppliers.filter((selectedSupplier) => selectedSupplier !== supplier.idprovider)})} />
                                          </div>
                                        </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div style={{ margin: "15px", border: "1px solid rgb(229, 231, 235)", borderRadius: "10px", padding: "15px" }}>
                                  <label>Nenhum fornecedor selecionado</label>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Stocks",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                }) : {
                  label: "Stocks",
                  page: (<h1>O produto não movimenta stock.</h1>)
                },
                composition: composed ? (edit ? {
                  label: "Ficha Técnica",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Ficha Técnica{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                            <div onClick={() => eventBus.$emit("Modal-composition", { header: "Adicionar produto", body: null })}>
                              <MdAddCircleOutline
                                style={{ fontSize: "20px", cursor: "pointer" }}
                              />
                            </div>
                          </div>
                          <div>
                            <MDBDataTable
                              data={compositionTable}
                              striped
                              bordered
                              searching={false}
                              paging={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Ficha Técnica",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                }) : {
                  label: "Ficha Técnica",
                  page: (<h1>O produto não é composto.</h1>)
                },
                in: mov_stock ? (edit ? {
                  label: "Mov. Entradas",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Mov. Entradas{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div>
                              <VerticalTabs
                                tabs={[
                                  {
                                    label: "Todos Postos",
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse="all"
                                          columns={movEntradas.columns.filter(({accessor}) => accessor !== 'stock')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movEntradas.data}
                                          pages={movEntradas.pages} // Display the total number of pages
                                          loading={movEntradas.loading} // Display the loading overlay when we need it
                                          onFetchData={
                                            this.fetchMovEntradasData
                                          } // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  },
                                  ...warehouses.map((warehouse) => ({
                                    label: warehouse.nome || warehouse.posto,
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse={warehouse.posto}
                                          columns={movEntradas.columns.filter(({id}) => id !== 'posto')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movEntradas.data}
                                          pages={movEntradas.pages} // Display the total number of pages
                                          loading={movEntradas.loading} // Display the loading overlay when we need it
                                          onFetchData={
                                            this.fetchMovEntradasData
                                          } // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  })),
                                ]}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Mov. Entradas",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                }) : {
                  label: "Mov. Entradas",
                  page: (<h1>O produto não movimenta stock.</h1>)
                },
                out: mov_stock ? (edit ? {
                  label: "Mov. Saidas",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Mov. Saidas{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div>
                              <VerticalTabs
                                tabs={[
                                  {
                                    label: "Todos Postos",
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse="all"
                                          columns={movSaidas.columns.filter(({accessor}) => accessor !== 'stock')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movSaidas.data}
                                          pages={movSaidas.pages} // Display the total number of pages
                                          loading={movSaidas.loading} // Display the loading overlay when we need it
                                          onFetchData={this.fetchMovSaidasData} // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  },
                                  ...warehouses.map((warehouse) => ({
                                    label: warehouse.nome || warehouse.posto,
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse={warehouse.posto}
                                          columns={movSaidas.columns.filter(({id}) => id !== 'posto')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movSaidas.data}
                                          pages={movSaidas.pages} // Display the total number of pages
                                          loading={movSaidas.loading} // Display the loading overlay when we need it
                                          onFetchData={this.fetchMovSaidasData} // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  })),
                                ]}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Mov. Saidas",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                }) : {
                  label: "Mov. Saidas",
                  page: (<h1>O produto não movimenta stock.</h1>)
                },
                inout: mov_stock ? (edit ? {
                  label: "Mov. E/S",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Mov. Entradas e Saídas{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div>
                              <VerticalTabs
                                tabs={[
                                  {
                                    label: "Todos Postos",
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse="all"
                                          columns={movEntradasSaidas.columns.filter(({accessor}) => accessor !== 'stock')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movEntradasSaidas.data}
                                          pages={movEntradasSaidas.pages} // Display the total number of pages
                                          loading={movEntradasSaidas.loading} // Display the loading overlay when we need it
                                          onFetchData={
                                            this.fetchMovEntradasSaidasData
                                          } // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  },
                                  ...warehouses.map((warehouse) => ({
                                    label: warehouse.nome || warehouse.posto,
                                    component: (
                                      <div>
                                        <ReactTable
                                          warehouse={warehouse.posto}
                                          columns={movEntradasSaidas.columns.filter(({id}) => id !== 'posto')}
                                          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                          sortable={false}
                                          data={movEntradasSaidas.data}
                                          pages={movEntradasSaidas.pages} // Display the total number of pages
                                          loading={movEntradasSaidas.loading} // Display the loading overlay when we need it
                                          onFetchData={
                                            this.fetchMovEntradasSaidasData
                                          } // Request new data when things change
                                        />
                                      </div>
                                    ),
                                  })),
                                ]}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Mov. Entradas",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                }) : {
                  label: "Mov. Entradas",
                  page: (<h1>O produto não movimenta stock.</h1>)
                },
                barcodes: edit ? {
                  label: "Cod. Barras",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Cod. Barras{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                            <div onClick={() => eventBus.$emit("Modal-barcodes", { header: "Novo código de barras", body: null })}>
                              <MdAddCircleOutline
                                style={{ fontSize: "20px", cursor: "pointer" }}
                              />
                            </div>
                          </div>
                          {loaded && (
                            <div>
                              {barcodes.map(({barcode}) => (
                                <div>
                                  <Barcode value={barcode} /><i style={{ fontSize: '15px', cursor: 'pointer' }} onClick={ () => this.handleBarcodeDeleteSuccess(barcode) } className="fas fa-trash"></i>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Cod. Barras",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                },
                history: edit ? {
                  label: "Histórico",
                  page: (
                    <div className="fullContainer" style={{ maxWidth: "100%" }}>
                      <div
                        className="col-sm-12"
                        style={{ textAlign: "center" }}
                      >
                        <div className="panel panel-default">
                          <div
                            className="panel-heading"
                            style={{
                              fontWeight: "bold",
                              fontSize: "15pt",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: '15px'
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "left",
                              }}
                            >
                              Histórico{" "}
                              <h6>
                                {edit ? (
                                  <span>{name}</span>
                                ) : (
                                  <span>Novo Produto</span>
                                )}
                              </h6>
                            </div>
                          </div>
                          {loaded && (
                            <div style={{ padding: "15px" }}>
                              <div style={{ marginBottom: "15px" }}>
                                <Input
                                  inputType={"text"}
                                  name={"historySearch"}
                                  value={historyData.search}
                                  placeholder="Pesquisar no histórico..."
                                  handleChange={(e) => {
                                    this.setState({
                                      historyData: {
                                        ...historyData,
                                        search: e.target.value
                                      }
                                    });
                                  }}
                                  style={{ maxWidth: "400px", display: "inline-block" }}
                                />
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    this.setState({
                                      historyData: {
                                        ...historyData,
                                        loading: true
                                      }
                                    });
                                    const profile = this.context;
                                    productsService.getHistory(
                                      profile.idEmpresaSec,
                                      this.state.idproduct.value,
                                      historyData.search,
                                      1,
                                      10
                                    )
                                    .then((data) => {
                                      const totalPages = data.length < 10 ? 1 : 2;
                                      this.setState({
                                        historyData: {
                                          ...historyData,
                                          data: data,
                                          pages: totalPages,
                                          loading: false,
                                        },
                                      });
                                    })
                                    .catch((error) => {
                                      console.error('Erro ao buscar histórico:', error);
                                      this.setState({
                                        historyData: {
                                          ...historyData,
                                          data: [],
                                          pages: 0,
                                          loading: false,
                                        },
                                      });
                                    });
                                  }}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Pesquisar
                                </button>
                              </div>
                              <div className="history-table-wrapper">
                                <ReactTable
                                  columns={historyData.columns}
                                  manual
                                  sortable={false}
                                  data={historyData.data}
                                  pages={historyData.pages}
                                  loading={historyData.loading}
                                  onFetchData={this.fetchHistoryData}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                } : {
                  label: "Histórico",
                  page: (<h1>Apenas disponivel após criação do produto</h1>)
                },
                ...(isAdmin && edit ? {
                  changeCode: {
                    label: "⭐ Alterar Código (ADMIN)",
                    page: (
                      <div className="fullContainer" style={{ maxWidth: "100%" }}>
                        <div
                          className="col-sm-12"
                          style={{ textAlign: "center" }}
                        >
                          <div className="panel panel-default">
                            <div
                              className="panel-heading"
                              style={{
                                fontWeight: "bold",
                                fontSize: "15pt",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: '15px'
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  textAlign: "left",
                                }}
                              >
                                Alterar Código do Produto{" "}
                                <h6>
                                  {edit ? (
                                    <span>{name}</span>
                                  ) : (
                                    <span>Novo Produto</span>
                                  )}
                                </h6>
                              </div>
                            </div>
                            {loaded && (
                              <div style={{ padding: "30px", textAlign: "left" }}>
                                <div style={{ marginBottom: "20px", padding: "20px", backgroundColor: "#fff3cd", borderRadius: "8px", border: "1px solid #ffc107" }}>
                                  <h5 style={{ marginTop: 0, color: "#856404", display: "flex", alignItems: "center", gap: "10px" }}>
                                    <i className="fas fa-exclamation-triangle"></i>
                                    Aviso Importante
                                  </h5>
                                  <p style={{ marginBottom: 0, color: "#856404", lineHeight: "1.6" }}>
                                    Esta operação irá alterar o código do produto em <strong>todas as tabelas</strong> da base de dados, incluindo históricos, transações, encomendas, vendas e stocks. Esta ação <strong>não pode ser revertida</strong> automaticamente.
                                  </p>
                                </div>
                                
                                <div style={{ marginBottom: "20px" }}>
                                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                    Código Atual
                                  </label>
                                  <div style={{ padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef", fontFamily: "monospace", fontSize: "16px" }}>
                                    {idproduct.value}
                                  </div>
                                </div>

                                <div style={{ marginBottom: "20px" }}>
                                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                    Novo Código
                                  </label>
                                  <Input
                                    inputType={"text"}
                                    name={"newProductCode"}
                                    value={newProductCode}
                                    handleChange={this.handleChange}
                                    placeholder="Introduza o novo código do produto"
                                    style={{ maxWidth: "400px" }}
                                  />
                                  <div style={{ fontSize: "0.875rem", color: "#666", marginTop: "5px" }}>
                                    O novo código deve ser único e não pode estar em uso por outro produto.
                                  </div>
                                </div>

                                <div style={{ marginBottom: "30px" }}>
                                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>
                                    Confirmação
                                  </label>
                                  <Input
                                    inputType={"text"}
                                    name={"changeCodeConfirmText"}
                                    value={changeCodeConfirmText}
                                    handleChange={this.handleChange}
                                    placeholder="Escreva 'CONFIRMAR' para confirmar"
                                    style={{ maxWidth: "400px" }}
                                  />
                                  <div style={{ fontSize: "0.875rem", color: "#666", marginTop: "5px" }}>
                                    Para confirmar esta alteração irreversível, escreva <strong>CONFIRMAR</strong> no campo acima.
                                  </div>
                                </div>

                                <div style={{ display: "flex", gap: "10px" }}>
                                  <Button
                                    action={this.handleChangeCodeSubmit}
                                    type={"danger"}
                                    title={"Alterar Código"}
                                    style={buttonStyle}
                                    disabled={!newProductCode || newProductCode.trim() === '' || changeCodeConfirmText !== 'CONFIRMAR'}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ),
                  }
                } : {}),
              }}
            />
          )}
          <Button
            action={this.handleFormSubmit}
            type={"success"}
            title={"Submeter"}
            style={buttonStyle}
          />
          <Button
            action={this.handleFormCancel}
            type={"secondary"}
            title={"cancelar"}
            style={buttonStyle}
          />
        </div>
        
        {/* Modal de Busca de Imagens Externas */}
        {showFetchImagesModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1050,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto"
            }}
            onClick={this.handleFetchImagesClose}
          >
            <div
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "8px",
                minWidth: "600px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                overflow: "auto"
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4 style={{ marginTop: 0, marginBottom: "20px", color: "#2b4c7e", fontWeight: "600" }}>
                Buscar Imagens Online
              </h4>
              
              {/* Campo de Pesquisa */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <Input
                    inputType={"text"}
                    name={"imageSearchQuery"}
                    value={imageSearchQuery}
                    placeholder="Código de barras ou nome do produto..."
                    handleChange={(e) => this.setState({ imageSearchQuery: e.target.value })}
                    style={{ flex: 1 }}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={this.fetchExternalImages}
                    disabled={fetchingImages || !imageSearchQuery}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {fetchingImages ? "A buscar..." : "Buscar"}
                  </button>
                </div>
              </div>

              {/* Lista de Imagens */}
              {fetchingImages && (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: "32px", color: "#007bff" }}></i>
                  <p style={{ marginTop: "10px", color: "#666" }}>A procurar imagens...</p>
                </div>
              )}

              {!fetchingImages && externalImages.length > 0 && (
                <div>
                  <div style={{ marginBottom: "15px", color: "#666", fontSize: "14px" }}>
                    Encontradas {externalImages.length} imagem{externalImages.length !== 1 ? 's' : ''}
                  </div>
                  <div style={{ 
                    display: "grid", 
                    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", 
                    gap: "15px",
                    maxHeight: "400px",
                    overflow: "auto"
                  }}>
                    {externalImages.map((img, index) => (
                      <div
                        key={index}
                        onClick={() => this.handleImageSelect(img.url)}
                        style={{
                          position: "relative",
                          cursor: "pointer",
                          border: selectedExternalImage === img.url ? "3px solid #007bff" : "2px solid #dee2e6",
                          borderRadius: "8px",
                          overflow: "hidden",
                          transition: "all 0.2s"
                        }}
                      >
                        <img
                          src={img.url}
                          alt={`Imagem ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "contain",
                            backgroundColor: "#f8f9fa",
                            display: "block"
                          }}
                        />
                        {selectedExternalImage === img.url && (
                          <div style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "#007bff",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white"
                          }}>
                            ✓
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {!fetchingImages && externalImages.length === 0 && imageSearchQuery && (
                <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
                  <i className="fas fa-image" style={{ fontSize: "48px", marginBottom: "15px" }}></i>
                  <p>Nenhuma imagem encontrada</p>
                </div>
              )}

              {/* Botões de Ação */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                <button
                  className="btn btn-secondary"
                  onClick={this.handleFetchImagesClose}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={this.handleUseSelectedImage}
                  disabled={!selectedExternalImage}
                  style={{ opacity: !selectedExternalImage ? 0.5 : 1 }}
                >
                  Usar Imagem Selecionada
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Confirmação de Alteração de Código */}
        {showChangeCodeConfirmModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1060,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto"
            }}
            onClick={() => this.setState({ showChangeCodeConfirmModal: false })}
          >
            <div
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "8px",
                minWidth: "500px",
                maxWidth: "90vw",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4 style={{ marginTop: 0, marginBottom: "20px", color: "#dc3545", fontWeight: "600", display: "flex", alignItems: "center", gap: "10px" }}>
                <i className="fas fa-exclamation-triangle"></i>
                Confirmar Alteração de Código
              </h4>
              
              <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#fff3cd", borderRadius: "6px", border: "1px solid #ffc107" }}>
                <p style={{ margin: 0, color: "#856404", lineHeight: "1.6" }}>
                  <strong>Atenção:</strong> Esta operação irá alterar o código do produto de <strong>{idproduct.value}</strong> para <strong>{newProductCode}</strong> em <strong>todas as tabelas</strong> da base de dados.
                </p>
                <p style={{ margin: "10px 0 0 0", color: "#856404", lineHeight: "1.6" }}>
                  Esta ação <strong>não pode ser revertida</strong> automaticamente. Tem a certeza que deseja continuar?
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => this.setState({ showChangeCodeConfirmModal: false })}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-danger"
                  onClick={this.handleChangeCodeConfirm}
                >
                  Confirmar Alteração
                </button>
              </div>
            </div>
          </div>
        )}

        <Modal id="barcodes">
          <div>
            <Input
                inputType={"text"}
                name={"newbarcode"}
                value={newbarcode}
                handleChange={this.handleChange}
            />
            <Button
                action={this.handleBarcodeSubmitSuccess}
                type={"success"}
                title={"Submeter"}
                style={buttonStyle}
            />
          </div>
        </Modal>
        <Modal id="composition">
          <div>
            <AutoComplete
                name={`selectedProduct`}
                value={selectedProduct}
                handleChange={this.handleChange}
                options={products.filter(({inativo}) => inativo !== 't')}
            />
            <br/>
            <input
              type="number"
              key={'selectedquantity'}
              name={'selectedquantity'}
              value={ selectedquantity }
              onChange={this.handleChange}
            />
            <br/>
            <Button
                action={this.handleCompositionSubmitSuccess}
                type={"success"}
                title={"Submeter"}
                style={buttonStyle}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

const buttonStyle = {
  margin: "10px 10px 10px 10px",
};

export default withCookies(Form);
